(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cw-klarna-installments"] && !Shopify.designMode) return;
  try {
    class CWKlarnaInstallments extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.generation = (this.generation || 0) + 1;
      this.pending = false;
      this.available = this.dataset.available === 'true';
      this.unitMinor = Number(this.dataset.unitMinor);
      this.section = this.closest('.shopify-section');
      this.hidden = true;
      if (!this.section || this.closest('product-card, dialog')) return;
      const euroCountries = ['FR', 'DE', 'AT', 'FI', 'IE', 'IT', 'NL', 'PT', 'ES'];
      this.allowed = this.dataset.currency === 'EUR' && euroCountries.includes(this.dataset.country);
      if (!this.allowed) return;
      this.formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency,
      });
      const options = { signal: this.controller.signal };
      this.section.addEventListener('shopify:product:select', (event) => this.onProductSelect(event), options);
      for (const name of ['quantity-selector:update', 'input', 'change']) {
        this.section.addEventListener(name, (event) => {
          if (event.target?.closest?.('product-form-component') !== this.getForm()) return;
          if (name !== 'quantity-selector:update' && !event.target?.closest?.('quantity-selector-component')) return;
          this.render();
        }, options);
      }
      document.addEventListener('shopify:cart:lines-update', (event) => {
        Promise.resolve(event.promise).then(() => this.scheduleRender()).catch(() => {});
      }, options);
      this.render();
      this.scheduleRender();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.generation = (this.generation || 0) + 1;
      cancelAnimationFrame(this.frame);
    }

    normalizeId(value) {
      return String(value ?? '').split('/').pop();
    }

    getForm() {
      return Array.from(this.section?.querySelectorAll('product-form-component') || []).find((form) =>
        this.normalizeId(form.dataset.productId) === this.dataset.productId && !form.closest('product-card, dialog')
      );
    }

    scheduleRender() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (this.isConnected) this.render();
      });
    }

    async onProductSelect(event) {
      const sourceContext = event.target?.closest?.('product-card, dialog');
      if (sourceContext && !sourceContext.contains(this)) return;
      if (event.product?.id && this.normalizeId(event.product.id) !== this.dataset.productId) return;
      if (!event.promise) return;
      const generation = ++this.generation;
      this.pending = true;
      this.available = false;
      this.hidden = true;
      try {
        const result = await event.promise;
        if (generation !== this.generation || !this.isConnected) return;
        const detail = result?.detail;
        if (detail?.newProduct) return;
        if (detail?.productId && this.normalizeId(detail.productId) !== this.dataset.productId) return;
        const resource = detail?.resource;
        if (!resource?.available || !Number.isSafeInteger(resource.price) || resource.price <= 0) return;
        this.unitMinor = resource.price;
        this.available = true;
      } catch {
        if (generation === this.generation) this.available = false;
      } finally {
        if (generation === this.generation && this.isConnected) {
          this.pending = false;
          this.scheduleRender();
        }
      }
    }

    render() {
      this.hidden = true;
      if (!this.allowed || !this.available || this.pending || !Number.isSafeInteger(this.unitMinor) || this.unitMinor <= 0) return;
      const form = this.getForm();
      if (!form) return;
      const quantitySelector = form.querySelector('quantity-selector-component');
      const input = quantitySelector?.querySelector('input[ref="quantityInput"]');
      if (input && (!input.value.trim() || !input.validity.valid)) return;
      if (quantitySelector?.canAddToCart && !quantitySelector.canAddToCart().canAdd) return;
      const quantity = input ? Number(input.value) : Number(form.dataset.quantityDefault || this.dataset.quantity || 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const total = this.unitMinor * quantity;
      if (!Number.isSafeInteger(total) || total < 3) return;
      const firstMinor = Math.floor(total / 3);
      const lastMinor = total - firstMinor * 2;
      const first = this.formatter.format(firstMinor / 100);
      const last = this.formatter.format(lastMinor / 100);
      const amount = this.querySelector('[data-cw-klarna-amount]');
      const schedule = this.querySelector('[data-cw-klarna-schedule]');
      if (!amount || !schedule) return;
      const amountText = this.dataset.installments.split('__CW_AMOUNT__').join(first);
      const scheduleText = this.dataset.schedule.split('__CW_FIRST__').join(first).split('__CW_LAST__').join(last);
      if (amount.textContent !== amountText) amount.textContent = amountText;
      if (schedule.textContent !== scheduleText) schedule.textContent = scheduleText;
      this.hidden = false;
    }
  }

  if (!customElements.get('cw-klarna-installments')) {
    customElements.define('cw-klarna-installments', CWKlarnaInstallments);
  }
  } catch(e) { console.error(e); }
})();

})();
